<template>
  <div v-if="establishment && establishment.id">
    <h4>{{ title }}</h4>
    <div :class="{ 'box-block': !trainee }">
      <div v-if="monitor.visible" :class="monitor.type" class="alert">
        {{ monitor.message }}
      </div>
      <div v-show="!isLoading">
        <ValidationObserver ref="form" tag="div">
          <div v-if="!trainee">
            <div
              class="alert"
              :class="importForm.alert.type"
              v-if="importForm.alert.on"
            >
              {{ importForm.alert.text }}
            </div>
            <validation-provider
              name="file"
              rules="required"
              v-slot="{ errors }"
              class="w-100"
            >
              <div class="dropbox" :class="{ 'is-invalid': errors.length }">
                <input type="hidden" v-model="importForm.file" />
                <input
                  type="file"
                  id="assetsFieldHandle"
                  class="overflow-hidden position-absolute"
                  style="visibility: hidden"
                  @change="fileChange"
                  accept=".xlsx, .xls"
                />

                <label
                  for="assetsFieldHandle"
                  :class="{ 'is-invalid': errors.length }"
                  class="d-block"
                >
                  <div class="">
                    <div class="d-flex justify-content-center">
                      <div class="icon icon-upload"></div>
                    </div>
                    <div
                      class="p-1 d-flex align-items-center justify-content-center"
                      v-if="importForm.file"
                    >
                      {{ importForm.fileName }}
                      <button
                        type="button"
                        class="btn btn-icon px-0 py-0"
                        aria-label="remove"
                        title="Remove file"
                        @click.stop.prevent="removeFile()"
                      >
                        <span class="icon icon-cross icon-cross_danger"></span>
                      </button>
                    </div>

                    <div class="mt-3" v-if="!importForm.file">
                      {{ $t('addTraineeByUpload') }}
                    </div>
                  </div>
                </label>
              </div>
            </validation-provider>
            <div>
              <div class="text-right mt-3" v-if="importForm.file">
                <button
                  @click.prevent.stop="uploadFile"
                  :disabled="importForm.isLoaded"
                  class="btn btn-primary"
                >
                  {{ $t('import') }}
                </button>
              </div>
            </div>

            <div class="mx-auto py-3 text-center text-muted">
              {{ $t('orManually') }}
            </div>
            <!-- <span class="text-danger d-none">
              <small>{{ errors[0] }}</small>
            </span> -->
          </div>
        </ValidationObserver>
        <ValidationObserver ref="observer" tag="div" v-slot="{ invalid }">
          <form
            @submit.prevent="() => (trainee ? editTrainee() : addNewTrainee())"
          >
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label
                    >{{ $t('form.gender')
                    }}<sup class="text-danger">*</sup></label
                  >
                  <div>
                    <div
                      class="custom-control custom-control_light custom-radio custom-control-inline"
                    >
                      <validation-provider
                        name="gender"
                        rules="oneOf:1,2"
                        v-slot="{ errors }"
                      >
                        <input
                          type="radio"
                          :id="randId + 1"
                          v-model="form.gender"
                          value="1"
                          name="customRadioInline1"
                          class="custom-control-input"
                          :class="{ 'is-invalid': errors.length }"
                        />
                        <label class="custom-control-label" :for="randId + 1">{{
                          $t('form.mr')
                        }}</label>
                      </validation-provider>
                    </div>
                    <div
                      class="custom-control custom-control_light custom-radio custom-control-inline"
                    >
                      <validation-provider
                        name="gender"
                        rules="oneOf:1,2"
                        v-slot="{ errors }"
                      >
                        <input
                          type="radio"
                          :id="randId + 2"
                          v-model="form.gender"
                          value="2"
                          name="customRadioInline1"
                          class="custom-control-input"
                          :class="{ 'is-invalid': errors.length }"
                        />
                        <label class="custom-control-label" :for="randId + 2">{{
                          $t('form.mrs')
                        }}</label>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="Firstname"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="firstname"
                      >{{ $t('form.firstname')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.length }"
                      v-model="form.firstname"
                      id="firstname"
                      :placeholder="$t('form.firstname')"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="Lastname"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="lastname"
                      >{{ $t('form.lastname')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.length }"
                      v-model="form.lastname"
                      id="lastname"
                      :placeholder="$t('form.lastname')"
                    />
                    <!-- <span class="text-danger d-none">
                      <small>{{ errors[0] }}</small>
                    </span> -->
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="birthday"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="birthday"
                      >{{ $t('form.birthday')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <date-picker
                      v-model="form.birthday"
                      :format="$t('dateFormat')"
                      value-type="YYYY-MM-DD"
                      name="date"
                      :placeholder="$t('form.birthday')"
                      :lang="lang"
                      :class="{ 'is-invalid': errors.length }"
                      class="form-control form-control_date"
                      id="Date de naissance"
                    ></date-picker>
                    <!-- <span class="text-danger d-none">
                      <small>{{ errors[0] }}</small>
                    </span> -->
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="email"
                    rules="email|required"
                    v-slot="{ errors }"
                  >
                    <label for="email"
                      >{{ $t('form.email')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      v-model="form.email"
                      class="form-control"
                      id="email"
                      :class="{ 'is-invalid': errors.length }"
                      :placeholder="$t('form.email')"
                    />
                    <!-- <span v-cloak class="text-danger small">{{
                      errors[0]
                    }}</span> -->
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="Function"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="service"
                      >{{ $t('form.function')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <treeselect
                      :maxHeight="200"
                      id="function"
                      v-model="form.function_id"
                      :multiple="false"
                      :options="functions"
                      :normalizer="normalizer"
                      :placeholder="$t('form.function')"
                      :searchable="true"
                      :class="{ 'is-invalid': errors.length }"
                    >
                      <template v-slot:before-list>
                        <div class="m-2">
                          <div
                            class="text-muted text-xsmall line-height-1"
                            v-if="!functionsSearchValue"
                          >
                            {{ $t('typeToSearch') }}
                          </div>
                          <button
                            v-else
                            class="btn btn-icon w-100 p-0 justify-content-start"
                            @click.prevent="setTraineeOptions('functions')"
                          >
                            <span class="icon icon-plus"></span>
                            <span
                              >{{ $t('createNew') }} "{{
                                functionsSearchValue
                              }}"</span
                            >
                          </button>
                        </div>
                      </template>
                    </treeselect>
                    <!-- <span v-cloak class="text-danger small">{{
                      errors[0]
                    }}</span> -->
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="service"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="service"
                      >{{ $t('form.service')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <treeselect
                      :maxHeight="200"
                      id="service"
                      v-model="form.service_id"
                      :multiple="false"
                      :options="services"
                      :normalizer="normalizer"
                      :placeholder="$t('form.service')"
                      :searchable="true"
                      :class="{ 'is-invalid': errors.length }"
                    >
                      <template v-slot:before-list>
                        <div class="m-2">
                          <div
                            class="text-muted text-xsmall line-height-1"
                            v-if="!servicesSearchValue"
                          >
                            {{ $t('typeToSearch') }}
                          </div>
                          <button
                            v-else
                            class="btn btn-icon w-100 p-0 justify-content-start"
                            @click.prevent="setTraineeOptions('services')"
                          >
                            <span class="icon icon-plus"></span>
                            <span
                              >{{ $t('createNew') }} "{{
                                servicesSearchValue
                              }}"</span
                            >
                          </button>
                        </div>
                      </template>
                    </treeselect>
                    <!-- <span v-cloak class="text-danger small">{{
                      errors[0]
                    }}</span> -->
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="language"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="language"
                      >{{ $t('form.preferred_language')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <treeselect
                      :maxHeight="200"
                      id="language"
                      v-model="form.preferred_language"
                      :multiple="false"
                      :options="languages"
                      :placeholder="$t('form.preferred_language')"
                      :class="{ 'is-invalid': errors.length }"
                    />
                    <!-- <span v-cloak class="text-danger small">{{
                      errors[0]
                    }}</span> -->
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="pay_code"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="pay_code"
                      >{{ $t('form.pay_code')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.pay_code"
                      :class="{ 'is-invalid': errors.length }"
                      id="pay_code"
                      :placeholder="$t('form.pay_code')"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="training_manager_email"
                    rules="email|required"
                    v-slot="{ errors }"
                  >
                    <label for="training_manager_email"
                      >{{ $t('form.training_manager_email')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      v-model="form.training_manager_email"
                      class="form-control"
                      id="training_manager_email"
                      :class="{ 'is-invalid': errors.length }"
                      :placeholder="$t('form.training_manager_email')"
                    />
                    <!-- <span v-cloak class="text-danger small">{{
                      errors[0]
                    }}</span> -->
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="entry_date"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="entry_date"
                      >{{ $t('form.entry_date')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <date-picker
                      v-model="form.entry_date"
                      :format="$t('dateFormat')"
                      value-type="YYYY-MM-DD"
                      name="date"
                      :placeholder="$t('form.entry_date')"
                      :class="{ 'is-invalid': errors.length }"
                      :lang="lang"
                      class="form-control form-control_date"
                      id="entry_date"
                    ></date-picker>
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label for="release_date">{{
                    $t('form.release_date')
                  }}</label>
                  <date-picker
                    v-model="form.release_date"
                    :format="$t('dateFormat')"
                    value-type="YYYY-MM-DD"
                    name="date"
                    :placeholder="$t('form.release_date')"
                    :lang="lang"
                    class="form-control form-control_date"
                    id="release_date"
                  ></date-picker>
                </div>
              </div>
              <div class="col-12 col-md-4" v-if="trainee">
                <div class="form-group">
                  <label for="">
                    {{ $t('status.active')
                    }}<sup class="text-danger">*</sup></label
                  >
                  <div class="mt-2">
                    <div
                      class="custom-control custom-control_light custom-radio custom-control-inline"
                    >
                      <validation-provider
                        name="status-active"
                        rules="oneOf:0,1"
                        v-slot="{ errors }"
                      >
                        <input
                          v-model="form.status"
                          :value="1"
                          type="radio"
                          id="status-active"
                          name="status-active"
                          class="custom-control-input"
                        />
                        <label
                          class="custom-control-label"
                          for="status-active"
                          >{{ $t('yes') }}</label
                        >
                      </validation-provider>
                    </div>

                    <div
                      class="custom-control custom-control_light custom-radio custom-control-inline"
                    >
                      <validation-provider
                        name="status-inactive"
                        rules="oneOf:0,1"
                        v-slot="{ errors }"
                      >
                        <input
                          v-model="form.status"
                          :value="0"
                          type="radio"
                          id="status-inactive"
                          name="status-inactive"
                          class="custom-control-input"
                        />
                        <label
                          class="custom-control-label"
                          for="status-inactive"
                          >{{ $t('no') }}</label
                        >
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <div class="text-lg">{{ $t('managerInformations') }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="manager_firstname"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="manager_firstname"
                      >{{ $t('form.manager_firstname')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.manager_firstname"
                      id="manager_firstname"
                      :class="{ 'is-invalid': errors.length }"
                      :placeholder="$t('form.manager_firstname')"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="manager_lastname"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="manager_lastname"
                      >{{ $t('form.manager_lastname')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.manager_lastname"
                      id="manager_lastname"
                      :class="{ 'is-invalid': errors.length }"
                      :placeholder="$t('form.manager_lastname')"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <validation-provider
                    name="manager_email"
                    rules="email|required"
                    v-slot="{ errors }"
                  >
                    <label for="manager_email"
                      >{{ $t('form.manager_email')
                      }}<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      v-model="form.manager_email"
                      class="form-control"
                      id="manager_email"
                      :class="{ 'is-invalid': errors.length }"
                      :placeholder="$t('form.manager_email')"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="text-right mt-3">
              <button type="submit" class="btn btn-primary" :disabled="invalid">
                {{ trainee ? $t('editButton') : $t('addButton') }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    Treeselect,
  },
  name: 'TraineeForm',
  props: {
    title: {
      type: String,
      required: true,
    },
    trainee: {
      type: Object,
    },
  },
  data() {
    return {
      normalizer(node) {
        return {
          id: node.id,
          label: node.label,
        }
      },
      randId: `gender-id-${Math.round(Math.random() * 100)}`,
      additionalFields: false,
      isLoading: false,
      importForm: {
        isLoaded: false,
        file: null,
        fileName: '',
        alert: {
          on: false,
          type: '',
          text: '',
        },
      },
      form: {
        id: null,
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        function_id: null,
        service_id: null,
        gender: 0,
        preferred_language: null,
        status: null,
        pay_code: null,
        entry_date: null,
        release_date: null,
        training_manager_email: null,
        manager_email: null,
        manager_firstname: null,
        manager_lastname: null,
      },

      languages: ['FR', 'EN', 'NL', 'ES', 'IT', 'DK', 'SE', 'DE'].map((i) =>
        Object.assign({}, { id: i, label: i })
      ),
      servicesSearchValue: '',
      functionsSearchValue: '',
      lang: '',
      monitor: {
        visible: false,
        message: '',
        type: '',
      },
    }
  },

  async mounted() {
    this.isLoading = true
    this.lang = this.user?.local ?? this.locale
    const inputServices = document.querySelector(
      '#service input.vue-treeselect__input'
    )
    inputServices &&
      inputServices.addEventListener('input', (event) => {
        this.servicesSearchValue = event.target.value
        this.services = [...this.services]
      })
    const inputFunctions = document.querySelector(
      '#function input.vue-treeselect__input'
    )
    inputFunctions &&
      inputFunctions.addEventListener('input', (event) => {
        this.functionsSearchValue = event.target.value
        this.functions = this.functions ? [...this.functions] : []
      })

    await this.getTraineeOptions('functions')
    await this.getTraineeOptions('services')
    this.isLoading = false
  },
  watch: {
    trainee: {
      handler(val) {
        if (val) {
          this.formReset()
          this.fillForm()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapFields([
      'user',
      'establishment',
      'company',
      'trainees.services',
      'trainees.functions',
      'locale'
    ]),
  },
  methods: {
    removeFile() {
      this.importForm.fileName = null
      this.importForm.file = null
    },
    fileChange(e) {
      let files = e.target.files
      if (!files.length) return
      this.importForm.fileName =
        files[0].name.length > 20
          ? files[0].name.slice(0, 20).concat('...')
          : files[0].name
      this.importForm.file = files[0]
      this.importForm.fileType = files[0].type
    },
    hideAlert() {
      this.importForm.alert.on = false
      this.importForm.alert.type = ''
      this.importForm.alert.text = ''
    },
    uploadFile() {
      this.hideAlert()
      this.$refs.form.validate().then((success) => {
        if (!success) {
          this.importForm.alert.type = 'alert-danger'
          this.importForm.alert.text = this.$t('errors.requiredFields')
          this.importForm.alert.on = true
          setTimeout(() => {
            this.hideAlert()
          }, 1000)
          return
        }
        this.importForm.isLoaded = true
        let formData = new FormData()
        formData.append('file', this.importForm.file)
        formData.append('companyId', this.company.id)
        formData.append('establishmentId', this.establishment.id)

        this.$store
          .dispatch('importTrainee', formData)
          .then(() => {
            this.importForm.alert.type = 'alert-success'
            this.importForm.alert.text = this.$t('savedSuccessfully')
            this.importForm.alert.on = true
            setTimeout(() => {
              this.hideAlert()
              this.removeFile()
              this.$bus.$emit('trainees-updated', false)
            }, 10000)
          })
          .catch((error) => {
            console.log(error)
            this.importForm.alert.type = 'alert-danger'
            this.importForm.alert.on = true
            if (error.response.status == 422) {
              this.importForm.alert.text = this.$t('errors.fileType')
            } else {
              this.importForm.alert.text = this.$t('savedError')
            }
            setTimeout(() => {
              this.hideAlert()
            }, 10000)
          })
          .finally(() => {
            this.importForm.isLoaded = false
          })

        // const formData = new FormData();
        // const fieldsParams = {};
        // formData.append( 'file', this.file );
        //formData.append( 'traineeHabilitationId', this.habilitation.id );
        // fieldsParams.trainee_id = this.habilitation.traineeId;
        // fieldsParams.traineeHabilitationId = this.habilitation.id;
        // fieldsParams.dlv = this.validUntil;
        // fieldsParams.certificate_number = this.certificateNumber;
        // this.$store
        //     .dispatch( 'habilitations/uploadHabilitationFile', formData )
        //     .then( async ( resp ) => {
        //       this.$store
        //           .dispatch( 'habilitations/updateHabilitation', fieldsParams )
        //           .then( async ( resp ) => {
        //             this.alert.type = "text-success";
        //             this.alert.text = this.$t("savedSuccessfully");
        //             this.alert.on = true;
        //             setTimeout( () => {
        //               this.hideModal();
        //               this.$bus.$emit( 'update-habilitations-list', false);
        //             }, 2000 );
        //           } )
        //           .catch( ( error ) => {
        //             console.log( error );
        //             if ( error.response.status == 422 ) {
        //               this.file = null;
        //               this.alert.type = 'text-danger';
        //               this.alert.text = this.$t( 'errors.fileType' );
        //               this.alert.on = true;
        //             } else {
        //               this.file = null;
        //               this.alert.type = 'text-danger';
        //               this.alert.text = this.$t( 'errors.serverError' );
        //               this.alert.on = true;
        //             }
        //           } )
        //           .finally( () => {
        //             this.isLoaded = false;
        //           } );
        //     } )
        //     .catch( ( error ) => {
        //       console.log( error );
        //       this.isLoaded = false;
        //       if ( error.response.status == 422 ) {
        //         this.file = null;
        //         this.alert.type = 'text-danger';
        //         this.alert.text = this.$t( 'errors.fileType' );
        //         this.alert.on = true;
        //       } else {
        //         this.file = null;
        //         this.alert.type = 'text-danger';
        //         this.alert.text = this.$t( 'errors.serverError' );
        //         this.alert.on = true;
        //       }
        //     } );
      })
    },
    fillForm() {
      this.form.id = this.trainee.id || null
      this.form.firstname = this.trainee.firstname || null
      this.form.lastname = this.trainee.lastname || null
      this.form.birthday = this.trainee.birthday || null
      this.form.email = this.trainee.email || null
      this.form.function_id = this.trainee.functionId || null
      this.form.service_id = this.trainee.serviceId || null
      this.form.gender = this.trainee.gender || 0
      this.form.preferred_language = this.trainee.preferredLanguage || null
      this.form.pay_code = this.trainee.payCode || null
      this.form.entry_date = this.trainee.entry_date || null
      this.form.release_date = this.trainee.release_date || null
      this.form.status = this.trainee?.status ? 1 : 0
      this.form.training_manager_email =
        this.trainee.training_manager_email || null
      this.form.manager_email = this.trainee.manager_email || null
      this.form.manager_firstname = this.trainee.manager_firstname || null
      this.form.manager_lastname = this.trainee.manager_lastname || null
    },
    formReset() {
      this.isLoading = false
      this.hideMessage()
      this.additionalFields = false
      this.$refs?.observer?.reset()
      this.form = {
        id: null,
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        function_id: null,
        service_id: null,
        gender: 0,
        preferred_language: null,
        pay_code: null,
        entry_date: null,
        release_date: null,
        training_manager_email: null,
        manager_email: null,
        manager_firstname: null,
        manager_lastname: null,
      }
    },
    addNewTrainee() {
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          this.showMessage(this.$t('errors.requiredFields'), 'error')
          setTimeout(() => {
            this.hideMessage()
          }, 1500)
          return
        }

        this.isLoading = true
        this.showMessage(this.$t('loading'))
        let params = {}
        params = this.form
        params.client_id = this.user.id
        params.establishment_id = this.establishment.id
        params.to_client_id = this.company.id
        params.establishment_title = this.establishment.title
        // params.id = null;
        if (![1, 2].includes(this.user.clientType)) params.status = true
        this.$store
          .dispatch('addTrainee', params)
          .then((response) => {
            if (response.status === 201) {
              this.isLoading = false
              this.showMessage(this.$t('team.addedSuccessfully'), 'success')
              params.id = response.data.data.id
              this.$store.commit('ADD_TRAINEE', params)
              this.formReset()
              this.$bus.$emit('trainees-added', params.id)
              setTimeout(() => {
                this.hideMessage()
              }, 1500)
            }
          })
          .catch((error) => {
            console.log('error', error)
            this.isLoading = false
            this.showMessage('Error', 'error')
            setTimeout(() => {
              this.hideMessage()
            }, 1500)
          })
      })
    },
    editTrainee() {
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          this.showMessage(this.$t('errors.requiredFields'), 'error')
          setTimeout(() => {
            this.hideMessage()
          }, 1500)
          return
        }
        this.isLoading = true
        this.showMessage(this.$t('loading'))

        let data = {}

        data.payload = this.form
        data.payload.service_id = this.form.service_id || null
        data.payload.function_id = this.form.function_id || null
        data.id = this.form.id

        this.$store
          .dispatch('editTrainee', data)
          .then((response) => {
            this.$bus.$emit('trainees-updated', data)
            this.$bus.$emit('trainee-settings-modal.hide')
          })
          .catch((error) => {
            this.showMessage(this.$t('errors.serverError'), 'error')
            console.log(error)
            setTimeout(() => {
              this.hideMessage()
            }, 1500)
          })
          .finally(() => {
            this.isLoading = false
          })
      })
    },
    setTraineeOptions(type = 'services') {
      this.isLoading = true
      this.showMessage('Loading..')
      let title = this[`${type}SearchValue`]
      if (title.length === 0) return false
      this.$store
        .dispatch('trainees/setTraineeOptions', {
          establishmentId: this.establishment.id,
          type,
          title,
        })
        .then((resp) => {
          this.getTraineeOptions(type)
          this.isLoading = false
          this[`${type}SearchValue`] = ''
          this.hideMessage()
        })
    },
    async getTraineeOptions(type = 'services') {
      await this.$store
        .dispatch('trainees/getTraineeOptions', {
          establishmentId: this.establishment.id,
          type: type,
        })
        .then((resp) => {
          this[type] = resp.map((d) => ({
            id: d.id,
            label: d.title,
          }))
        })
    },
    showMessage(message, type = 'info') {
      const types = {
        success: 'alert-success',
        error: 'alert-danger',
        info: 'alert-info',
      }
      this.monitor.message = message
      this.monitor.type = types[type] || types.info
      this.monitor.visible = true
    },
    hideMessage() {
      this.monitor.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dropbox {
  border: 1px dashed #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 0;

  label {
    transition: 0.3s all;
    cursor: pointer;
    width: 100%;
    text-align: center;
    padding: 1rem;
    margin-bottom: 0;

    &:hover {
      background-color: #f1f4fb;
    }
  }
}

.dropbox.is-invalid {
  border: 1px dashed #ce0000;
}

.icon-upload {
  width: 24px;
  height: 24px;
}
</style>
